export const LOCALHOST_DOMAIN_ID = 4

export const DOMAINS = [
  {
    id: 1,
    key: 'uaeConsulting',
    name: 'uae-consulting'
  },
  {
    id: 2,
    key: 'sbt',
    name: 'sbt'
  },
  {
    id: 3,
    key: 'stg',
    name: 'stg'
  },
  {
    id: LOCALHOST_DOMAIN_ID,
    name: 'localhost'
  }
]



// WEBPACK FOOTER //
// ./src/constants/domainListPlatform.js